/** Route paths owned by the essentials onboarding flow (SELF-138). */
export const ONBOARDING_PATHS = {
  root: '/onboarding',
  verification: '/onboarding/verification',
  getStarted: '/onboarding/get-started',
} as const;
